var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-icon",on:{"click":function($event){$event.preventDefault();return _vm.downloadFile(_vm.message)}}},[_c('div',{class:_vm.classObject}),_c('div',[_vm._v(_vm._s(_vm.getFileName()))])])}
var staticRenderFns = []

export { render, staticRenderFns }